'use client'

import { useContext } from 'react'
import { CartContext } from '@/lib/commerce/providers/CartProvider'
import type { CartContextValue } from '@/lib/commerce/types/cart'

export function useCart(): CartContextValue {
  const ctx = useContext(CartContext)
  if (!ctx) throw new Error('useCart must be used within <CartProvider>')
  return ctx as CartContextValue
}
